<template>
  <GenericReport
    ref="report"
    class="maxh-1bar clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :extraParams="{ clientIds: value.id }"
    :selectable="true"
    @update:selected="(v) => (selected = v)"
    @rowClicked="showRowDetails"
  >
    <template v-slot:topbar-actions>
      <NewFwUpdateDialog ref="newDialog" />
      <FwUpdateDetailsDialog ref="detailsDialog"/>

      <v-btn :disabled="selected.length < 1" @click="cancelUpdates">
        Cancelar...
      </v-btn>

      <v-btn color="primary" @click="newItem">
        Enviar Update...
      </v-btn>

      <v-btn icon @click="() => $refs.report.checkDownload()">
        <v-icon>$csv</v-icon>
      </v-btn>
    </template>
  </GenericReport>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import NewFwUpdateDialog from '../../fwupdates/NewFwUpdateDialog'
import { FWUpdate } from '@/models'
import adapterSpec from '../../fwupdates/fw-updates-columns'
import FwUpdateDetailsDialog from '../../fwupdates/FwUpdateDetailsDialog.vue'

const reportSpec = {
  code: 'fw-updates',
  title: 'FW Updates',
  apiBase: '/firmware-updates'
}

export default {
  tabTitle: 'FW Updates',
  tabGroup: 'Módulo',
  components: {
    GenericReport,
    NewFwUpdateDialog,
    FwUpdateDetailsDialog
  },
  props: {
    value: { required: true }
  },
  data() {
    return {
      reportSpec,
      adapterSpec,
      selected: []
    }
  },

  methods: {
    reload() {
      this.$refs.report.reload()
    },

    showRowDetails({ row }) {
      this.$refs.detailsDialog.open(row.id)
    },

    async newItem() {
      let dialog = this.$refs.newDialog,
        res = await dialog.open()

      if (res != null) {
        this.$loading(async () => {
          await FWUpdate.save({
            firmwareId: res.id,
            clientIds: [this.value.id]
          })
          this.reload()
          this.$snack('Criado com sucesso')
        })
      }
    },

    async cancelUpdates() {
      let res = await this.$confirm({
        message: 'Deseja realmente cancelar estes firmware updates?',
        okText: 'Sim, cancelar',
        cancelText: 'Não, manter'
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selected) {
            await FWUpdate.delete(id)
          }
          this.reload()
          this.$snack('Cancelados com sucesso')
        })
      }
    }
  }
}
</script>

<style></style>
